// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3jVe_","right":"styles_right__MA4xN"};